// @flow
import _ from 'lodash'

const DEFAULT = 'default'

function googleAnaliticsGoal(category: string, event: string, label: string) {
  if (window.ga) window.ga('send', 'event', category, event, label)
}

function withEveryYandexCounter(callback) {
  if (!window._yandexActionsCounters) {
    window._yandexActionsCounters = []

    for (const i in window) {
      if (i.indexOf('yaCounter') === 0) window._yandexActionsCounters.push(window[i])
    }
  }

  _.every(window._yandexActionsCounters, (counter) => callback(counter))
}

function yandexGoal(category: string, event: string, label: string) {
  withEveryYandexCounter((counter) => {
    counter.reachGoal(event, { category: category, label: label })
  })
}

function trackGoal(category: ?string, event: ?string, label: ?string) {
  googleAnaliticsGoal(category || DEFAULT, event || DEFAULT, label || DEFAULT)
  yandexGoal(category || DEFAULT, event || DEFAULT, label || DEFAULT)
}

export { googleAnaliticsGoal, yandexGoal, trackGoal }
